module.exports = __webpack_public_path__ + "static/img/setAimLogo.1dd1db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setAimLogo.png
// module id = tUKy
// module chunks = 1